import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BuildingContactRoleService } from '@http/clients/building-contact-role.service';
import { IBaseDto } from '@http/clients/reporting-app/base-dto.service';
import { ReportsService } from '@services/reports.service';
import { ValidationErrorMessageComponent } from '@shared/validation-error-message/validation-error-message.component';
import { EditorComponentBase, GenericDropdownMultiselectComponent } from 'ngx-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-reporting-opportunity-company-role-editor',
    templateUrl: './reporting-opportunity-company-role-editor.component.html',
    styleUrls: ['./reporting-opportunity-company-role-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent, ValidationErrorMessageComponent]
})
export class ReportingOpportunityCompanyRoleEditorComponent
    extends EditorComponentBase<number[] | null>
    implements OnInit, OnDestroy
{
    source: IBaseDto[];
    selectedItems?: IBaseDto[];
    subscription?: Subscription;

    constructor(
        private readonly reportsService: ReportsService,
        private readonly buildingContactRoleService: BuildingContactRoleService
    ) {
        super();
        this.source = [];
    }

    async ngOnInit(): Promise<void> {
        this.source = await this.buildingContactRoleService.getByUsage(2, undefined);
        this.subscription = this.reportsService.selectedProperty$.subscribe(async (ready) => {
            if (
                ready &&
                this.source?.length &&
                this.bindingProperty !== null &&
                this.bindingProperty?.length &&
                Array.isArray(this.bindingProperty)
            ) {
                this.selectedItems = this.source.filter(
                    (obj) => this.bindingProperty?.find((id) => id === obj['id']) !== undefined
                );
            } else if (ready && (this.bindingProperty === null || this.bindingProperty === undefined)) {
                this.selectedItems = [];
            }
        });
    }

    onSelectedItemChange() {
        if (this.selectedItems?.length) {
            this.bindingProperty = this.selectedItems.map((obj) => obj.id);
        } else {
            this.bindingProperty = null;
        }
        this.valueChange.emit();
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
